import { defineComponent as _defineComponent } from 'vue'
import MyProjectsOverview from '@/views/my-projects/components/overview/MyProjectsOverview.vue';
import MyProjectsReceivedOffers from '@/views/my-projects/components/offers/MyProjectsReceivedOffers.vue';
import BCXAbsoluteTransition from '@/components/molecules/BCXAbsoluteTransition.vue';
import { useMyProjects } from '@/views/my-projects/composables/useMyProjects';
import { computed, ref, watch } from 'vue';
import useUser from '@/mixins/useUser';
import MyProjectsMadeOffers from '@/views/my-projects/components/offers/MyProjectsMadeOffers.vue';
import BCXNewStuffBanner from '@/components/molecules/BCXNewStuffBanner.vue';
import { useDocumentVisibility, useIntervalFn } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectOffers',
  setup(__props) {

const { isGuest } = useUser('self');

const isDocumentVisibleValue = useDocumentVisibility();
const isDocumentVisible = computed(() => isDocumentVisibleValue.value === 'visible');

const {
  selectedProjectWithOffers, isLoading, madeProjectsWithOffers, loadMyProjects, loadProjectsWithOffers, hasChanges, fullCheckForChanges, fullReloadProjectsWithOffers
} = useMyProjects();

(async () => {
  await loadMyProjects();
  await loadProjectsWithOffers();
})();

const isSliding = ref(false);

const intervalValue = ref(60000);
const { resume, pause } = useIntervalFn(() => {
  fullCheckForChanges();
}, intervalValue.value);

watch(() => isDocumentVisible.value, (value) => {
  if (value) {
    fullCheckForChanges();
    resume();
  } else {
    pause();
  }
});
const closeBanner = () => {
  hasChanges.value = false;
};

watch(selectedProjectWithOffers, async () => {
  await fullCheckForChanges();
  if (hasChanges.value) {
    closeBanner();
    fullReloadProjectsWithOffers();
  }
}, { immediate: true });

return { __sfc: true,isGuest, isDocumentVisibleValue, isDocumentVisible, selectedProjectWithOffers, isLoading, madeProjectsWithOffers, loadMyProjects, loadProjectsWithOffers, hasChanges, fullCheckForChanges, fullReloadProjectsWithOffers, isSliding, intervalValue, resume, pause, closeBanner, MyProjectsOverview, MyProjectsReceivedOffers, BCXAbsoluteTransition, MyProjectsMadeOffers, BCXNewStuffBanner }
}

})